<template>
    <div class="fn-login-page" style="margin-top:95px" v-if="!loading">
        <!--<meta name="google-signin-client_id" :content="google_client_id">-->
       <div class="row">
           <div class="col-md-3"></div>
            <div class="col-md-6">
                  <div class="fn-card">
                    <div class="fn-head-text">
                        Package Management System
                    </div>
                   
                    <div>
                       
                        <span>
                            <img src="../../static/images/money.png" style="width:100px">
                        </span>
                        
                    </div>
                    <div class="fn-text" style="margin-top:20px">
                      
                    </div>
                    <div>
                       <input type="text" class="fn-text-box" name="username" placeholder="USERNAME" v-model="username" required>
                    </div>
                    <div>
                        <input type="password" class="fn-text-box" name="password" v-model="password" placeholder="PASSWORD" required>
                    </div>
                    
                    <div style="margin-top:20px">
                        <button class="btn fn-btn-login waves-effect" @click="auth()">Login</button>
                    </div>
                     
                
            
                </div>
            </div>
            <div class="col-md-3"></div>
       </div>
    </div>

</template>

<script>
import { AuthService } from '../service';
import alertBox from '../classes/alertBox'


export default {
    name : "Login",
    data(){
        return {
            username : "",
            password : "",
            loading: true
        }
    },
    async created() {
       localStorage.clear()
        this.loading = false
    },
    mounted(){
      
    },
    methods: {
        async auth(){
            try{
                let response = await AuthService.login(this.username,this.password)
                localStorage.setItem('user',JSON.stringify(response.data))
                localStorage.setItem('date',response.date)
                localStorage.setItem('token',response.token)
                localStorage.setItem('refresh_token',response.refresh_token)    
                this.$router.push('/dashboard')
            }
            catch(error){
                console.log(error)
                alertBox.error('Invalid Username or Password!')
                localStorage.setItem('user',null)
            } 
            
        },
        
        
    }
}

</script>

<style scoped>
    
    .fn-login-page {
        /* background-color: #00BCD4; */
        margin: auto;
        padding-left: 0;
        margin: 5% auto;
        width: 103%;
    }
    .fn-card {
        background: #8bca84;
        min-height: 550px;
        -webkit-box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        position: relative;
        margin-bottom: 30px;
        border-radius: 2px;
    }
    .fn-head-text{
        padding-top: 30px;
        color: #0f6118;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 10px;
    }
    .fn-text-box{
        margin-top: 20px;
        color: white;
        background: #4CAF50;
        border: 2px solid #fff;
        height: 50px;
        width: 80%;
        padding-left: 5px;
    }
    .fn-text-box::placeholder{
        color: rgb(201, 246, 208);
        padding-left: 5px;
    }
    .fn-text-box::-ms-input-placeholder {
        color: rgb(201, 246, 208);
        padding-left: 5px;
    }
    .fn-btn-login{
        width: 80%;
        height: 50px;
        margin: auto;
        color:#2196F3;
        font-weight: bold;
        font-size: 16px;
        background: white;
    }
    .fn-btn-login:hover{
        color:white;
        background:#c6c6e6;
    }
    .fn-sign-up{
        cursor: pointer;
        color: #a3abd1;
        margin-left:10px;
        font-weight: bold;
    }
    .fn-sign-up:hover{
        color: white;
    }
    .fn-text{
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue